module.exports = __webpack_public_path__ + "img/reference66.76615fd2.jpg";